import { apiService } from './api';
import {
  AnalysisCombo,
  CreateAnalysisComboRequest,
  UpdateAnalysisComboRequest,
} from '../types/analysisCombo';

function unwrapResponse<T>(response: { success: boolean; data: T; message?: string }, fallbackError: string): T {
  if (!response.success || response.data === null || response.data === undefined) {
    throw new Error(response.message || fallbackError);
  }
  return response.data;
}

class AnalysisComboService {
  private baseUrl = '/analysis-combos';

  async getCombos(): Promise<AnalysisCombo[]> {
    const response = await apiService.get<AnalysisCombo[]>(this.baseUrl);
    return unwrapResponse(response, 'Failed to fetch analysis combos');
  }

  async getComboById(id: number): Promise<AnalysisCombo> {
    const response = await apiService.get<AnalysisCombo>(`${this.baseUrl}/${id}`);
    return unwrapResponse(response, 'Failed to fetch analysis combo');
  }

  async createCombo(data: CreateAnalysisComboRequest): Promise<AnalysisCombo> {
    const response = await apiService.post<AnalysisCombo>(this.baseUrl, data);
    return unwrapResponse(response, 'Failed to create analysis combo');
  }

  async updateCombo(id: number, data: UpdateAnalysisComboRequest): Promise<AnalysisCombo> {
    const response = await apiService.put<AnalysisCombo>(`${this.baseUrl}/${id}`, data);
    return unwrapResponse(response, 'Failed to update analysis combo');
  }

  async deleteCombo(id: number): Promise<void> {
    const response = await apiService.delete<object>(`${this.baseUrl}/${id}`);
    if (!response.success) {
      throw new Error(response.message || 'Failed to delete analysis combo');
    }
  }
}

export const analysisComboService = new AnalysisComboService();
